import React from "react";

export default function BookingTermsOfService() {
  return (
    <div>
      <h2 id="booking-terms-and-conditions">Booking Terms of Service</h2>
      <div>
        <p>
          This is a summary of our key Booking Terms and Conditions. It should
          not be a substitute for reading the full version below.
        </p>

        <ul>
          <li>
            <p>
              The Services you can buy or book via Obby are sold by our Partners
              and not by us. We are only responsible for arranging and
              concluding your booking and we have been appointed by our Partners
              to act as their commercial agent to do so.
            </p>
          </li>
          <li>
            <p>
              If you pay for Services from our Partners through our Website or
              our App, we may collect and receive your payment on behalf of the
              relevant Partner in our capacity as their commercial agent. In
              this event, our successful receipt of your payment will discharge
              your debt to the Partner for the Services.
            </p>
          </li>
          <li>
            <p>
              The contract for the Services is directly between you and the
              relevant Partner. We are not liable for the Services you receive
              from our Partners. However, please do let us know if you encounter
              a problem or if the Service you receive at a venue falls short of
              your expectations and we'll do our best to help.
            </p>
          </li>
          <li>
            <p>
              Please check all details and any restrictions relating to a
              Service thoroughly before booking.
            </p>
          </li>
          <li>
            <p>
              Please ensure that any medical or other allergy/health information
              is disclosed to Partners before your appointment or stay.
            </p>
          </li>
          <li>
            <p>
              If you want to reschedule or cancel a Dated Booking (and provided
              that rescheduling or cancellation (as applicable) is not
              prohibited by these Booking Terms and Conditions) this must be
              requested and completed by either:
            </p>
            <ul>
              <li>
                <p>using your Obby account via the Website;</p>
              </li>
              <li>
                <p>following the link in your Order Confirmation email; or</p>
              </li>
              <li>
                <p>
                  emailing our Customer Care team at{" "}
                  <a href="mailto:hello@obby.co.uk">hello@obby.co.uk</a>.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              If you want to cancel an "Anytime" booking (and provided that
              cancellation is not prohibited by these Booking Terms and
              Conditions) this must be requested and completed by either:
            </p>
            <ul>
              <li>
                <p>using your Obby account via the Website;</p>
              </li>
              <li>
                <p>following the link in your Order Confirmation email; or</p>
              </li>
              <li>
                <p>
                  emailing our Customer Care team at{" "}
                  <a href="mailto:hello@obby.co.uk">hello@obby.co.uk</a>.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              If you want to cancel an Obby Gift Card (and provided that
              cancellation is not prohibited by these Booking Terms and
              Conditions) this must be requested and completed by either:
            </p>
            <ul>
              <li>
                <p>using your Obby account via the Website;</p>
              </li>
              <li>
                <p>following the link in your Order Confirmation email; or</p>
              </li>
              <li>
                <p>
                  emailing our Customer Care team at{" "}
                  <a href="mailto:hello@obby.co.uk">hello@obby.co.uk</a>.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              Rules regarding cancellation vary depending on whether you have
              purchased a Dated Booking, an "Anytime" class or an Obby Gift
              Card:
            </p>
          </li>
          <li>
            <p>
              You may cancel a Obby Gift Card within 24 hours of receiving your
              Order Confirmation - and we can offer you a full refund, unless
              you have already used it to make a booking.
            </p>
          </li>
          <li>
            <p>
              You may cancel a Dated Booking within 24 hours of receiving your
              Order Confirmation provided the appointment is not due to take
              place in the next 24, 48 or 72 hours, as selected by the Partner.
              In such cases we can offer you a full refund. If however the
              appointment is due to take place within the next 24, 48 or 72
              hours, as selected by the Partner, you will not be entitled to a
              refund or a credit note.
            </p>
          </li>
          <li>
            <p>
              If you wish to cancel a Dated Booking more than 24 hours after
              receiving your Order Confirmation, and provided the applicable
              booking is not due to take place within the next 7 days, you will
              be entitled to a full refund of the applicable amount via the
              original method of payment.. If however the appointment is due to
              take place within the next 7 days, you will not be entitled to a
              refund or a credit note.
            </p>
          </li>
          <li>
            <p>
              If you want to talk to us, please get in touch with our team and
              we'd be happy to help:
            </p>
            <ul>
              <li>
                <p>
                  Email:
                  <a href="mailto:help@obby.co.uk">help@obby.co.uk</a>
                </p>
              </li>
              <li>
                <p>
                  Post: Obby, Huckletree West, 191 Wood Lane, Shepherd's Bush,
                  W12 7FP
                </p>
              </li>
            </ul>
          </li>
        </ul>

        <p>
          <u>Booking Terms and Conditions (Full)</u>
        </p>
        <p>
          Please read these Booking Terms and Conditions carefully before you
          complete any transactions via the Website, as these "Booking Terms and
          Conditions" will apply to your transaction. We recommend that you
          print a copy of these Booking Terms and Conditions for future
          reference. If you do not agree with these Booking Terms and
          Conditions, you must not use our Website to make a booking.
        </p>

        {/* DEFINED TERMS */}
        <ol>
          <li>
            <p>Defined Terms</p>
            <p>
              For ease of reference the following terms shall having the
              following meanings in these Booking Terms and Conditions:
            </p>
            <ol>
              <li>
                <p>
                  "Customer", "you" and "your" means you, the buyer of any
                  Services;
                </p>
              </li>
              <li>
                <p>
                  "Dated Booking" means a booking at a specific time/date with a
                  particular Partner for the provision of Services;
                </p>
              </li>
              <li>
                <p>"Order" has the meaning given in clause 19 below;</p>
              </li>
              <li>
                <p>
                  "Order Confirmation" has the meaning given in clause 19 below;
                </p>
              </li>
              <li>
                <p>
                  "Partner(s)" means our selected third party providers of goods
                  and services who offer their goods and services for sale via
                  our Website;
                </p>
              </li>
              <li>
                <p>
                  "Partner Contract" has the meaning given in clause 20 below;
                </p>
              </li>
              <li>
                <p>
                  "Partner Terms and Conditions" means any Partner terms and
                  conditions of sale and/or of business (including without
                  limitation that Partner's privacy policy, booking policy,
                  delivery policy, health and safety policy, and returns/refund
                  policy - as applicable)
                </p>
              </li>
              <li>
                <p>
                  "Services" means any products, goods and/or services of a
                  Partner offered for purchase or booking via the Website;
                </p>
              </li>
              <li>
                <p>
                  "Obby Contract" has the meaning given in clause 18 below; and
                </p>
              </li>
              <li>
                <p>
                  "Obby gift card" means any gift card issued by Obby and which
                  may be redeemed on the Website to discount the purchase price
                  of Services, in accordance with the clauses below. Obby Gift
                  Cards are available for purchase in any denominations.
                </p>
              </li>
            </ol>
          </li>
        </ol>
        {/* INTRODUCTION... */}
        <ol start="2">
          <li>
            <p>
              Introduction and relationship between you, us and third party
              partners
            </p>
            <ol>
              <li>
                <p>
                  This Website is operated by Obbyco Ltd. (t/a Obby), a company
                  registered in England under company number 10018497 and whose
                  registered office is at 110 Clifton Street, Stapleton House, 2
                  <sup>nd</sup> Floor, London, EC2A 4HT, ("Obby", "us", "we" or
                  "our" for short).
                </p>
              </li>
              <li>
                <p>
                  The Website allows you to book and pay for a broad range
                  courses from a variety of providers (our Partners). Those
                  Services are provided by our various Partners and not by us.
                  Obby is responsible for taking and concluding your bookings as
                  the commercial agent of the relevant Partners. The provision
                  of the Services booked via our Website is the responsibility
                  of the Partner which provides them. In the event you pay for
                  Services via the Obby Website, then your payment will either
                  be paid directly to the relevant Partner or will be received
                  by us acting as commercial agent on behalf of the Partner. If
                  we receive payment as commercial agent on behalf of the
                  relevant Partner, our receipt of the correct payment will
                  discharge your debt to that Partner.
                </p>
              </li>
              <li>
                <p>
                  The legal implication of this is that in when you purchase
                  Products/Services, it will create two binding legal contracts:
                </p>
                <ul>
                  <li>
                    <p>
                      a contract between you and Obby (under which Obby has
                      certain responsibilities to you in relation to the
                      purchase or booking) (the "Obby Contract"). That contract
                      is made based on these Booking Terms and Conditions; and
                    </p>
                  </li>
                  <li>
                    <p>
                      a contract between you and the relevant Partner in respect
                      of the provision or supply of the Products/Services which
                      you book through the Website (the "Partner Contract").
                      That contract may include separate{" "}
                      <u>Partner Terms and Conditions</u>, which we will notify
                      you of before you make a booking either on the relevant
                      Partner's page on the Website or by way of a link to such
                      Partner Terms and Conditions from that Partner's page on
                      the Website.
                    </p>
                  </li>
                  <li>
                    <p>
                      All Services available for purchase on the Website are
                      offered by Obby on behalf of its Partners. That is, Obby
                      takes and concludes your bookings as a commercial agent
                      for its Partners. Therefore, we are not responsible or
                      liable to you for the actual Services that are booked
                      through the Website (including those services purchased
                      using the Obby Gift Card).
                    </p>
                  </li>
                  <li>
                    <p>
                      We amend these Booking Terms and Conditions from time to
                      time as set out in clauses 25. Every time you wish to make
                      a transaction on the Website, please check these Booking
                      Terms and Conditions to ensure you understand the terms
                      which will apply at that time.
                    </p>
                  </li>
                </ul>
              </li>
            </ol>
          </li>
        </ol>
        {/* ORDERS AND HWO THE CONTRACT */}
        <ol start="3">
          <li>
            <p>Orders and how the contract is formed between you and us</p>
            <ol>
              <li>
                <p>
                  There are two types of orders ("Order") you can make on the
                  Website: (a) Orders for Services and (b) Orders for Obby Gift
                  Cards.
                </p>
              </li>
              <li>
                <p>
                  In respect of Orders for Services, there are two ways you can
                  place your Order:
                </p>
                <ul>
                  <li>
                    <p>a Dated Booking; or</p>
                  </li>
                  <li>
                    <p>an "Anytime Booking"</p>
                  </li>
                </ul>
              </li>
            </ol>
          </li>
        </ol>

        {/* SERVICES */}
        <ol start="4">
          <li>
            <p>Services</p>
            <ol>
              <li>
                <p>
                  Our Partners are under a legal duty to provide Services that
                  are in conformity with the relevant Partner Contract.
                </p>
              </li>
              <li>
                <p>
                  All Services shown on the Website are subject to availability
                  and the images and/or descriptions of the Services on the
                  Website are for illustrative purposes only and actual Services
                  may vary from those images and/or descriptions. We require our
                  Partners to ensure that all information provided by them for
                  display on their page of the Website is accurate, complete and
                  not misleading in any way but we cannot verify the information
                  which they provide to us. It will be each Partner's
                  responsibility to ensure that all of its Services listed on
                  the Website are available and accurately described.
                </p>
              </li>
              <li>
                <p>
                  If you are a consumer, you have legal rights in relation to
                  Services that are faulty or not as described. Advice about
                  your legal rights is available from your local Citizens'
                  Advice Bureau or Trading Standards office. Nothing in these
                  Booking Terms and Conditions will affect these legal rights.
                </p>
              </li>
              <li>
                <p>
                  It is your (or the person receiving the Services) sole
                  responsibility to communicate in advance any medical or
                  health-related conditions and/or special needs to Obby or to
                  the Partner that might affect or be affected by any Services
                  (for example without limitation, allergy information and
                  health issues). Subject to clauses 31 to 33, if you (or the
                  relevant recipient of the Services) fail to disclose any such
                  information to the applicable Partner, neither Obby nor the
                  relevant Partner shall be liable to you (or the recipient of
                  the Services) for any injury, loss or damages resulting from
                  the Services that could reasonably have been avoided if you
                  (or the recipient of the Services) had disclosed that
                  information prior to receiving the Services.
                </p>
              </li>
            </ol>
          </li>
        </ol>

        {/* CANCELATIONS */}
        <ol start="5">
          <li>
            <p>Cancellations</p>
            <ol>
              <li>
                <p>
                  In addition to your other legal rights, you may in certain
                  circumstances have the right to cancel a Partner Contract
                  and/or Obby Contract (as applicable) and receive a refund or a
                  credit note in accordance with the terms set out in clauses 20
                  and 21.
                </p>
              </li>
              <li>
                <p>
                  If you change your mind about an Order for a Dated Booking or
                  an Obby Gift Card and wish to cancel it, the following
                  cancellation terms apply:
                </p>
                <ul>
                  <li>
                    <p>Dated bookings</p>
                    <ol>
                      <li>
                        <p>
                          <span>
                            If you cancel (in whole or in part) a Dated Booking
                            within 24 hours of receiving your Order Confirmation
                            you will be entitled to a full refund of the
                            applicable amount via the original method of
                            payment.
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                            If you cancel (in whole or in part) a Dated Booking
                            more than 24 hours after receiving your Order
                            Confirmation provided the applicable booking is not
                            due to take place within the next 7 days (or in some
                            cases as determined by the relevant Partner), you
                            will be entitled to a full refund of the applicable
                            amount via the original method of payment.
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          {" "}
                          <span>
                            If the booking is due to take place within the next
                            7 days, you will not be entitled to any refund or
                            credit note. The booking may however be transferred
                            to another person at no additional cost (e.g. you
                            may find a friend to take your place on the
                            experience and ask them for the money).
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          If permitted by these Booking Terms and Conditions and
                          the relevant Partner Terms and Conditions,
                          cancellations of Dated Bookings must be made by one of
                          the following methods:
                        </p>
                        <ul>
                          <li>
                            <p>
                              Emailing our Customer Care team on{" "}
                              <a href="mailto:hello@obby.co.uk">
                                hello@obby.co.uk
                              </a>
                              .
                            </p>
                          </li>
                          <li>
                            <p>
                              Please note that in a small number of
                              circumstances it may not be possible to cancel a
                              dated booking but we will draw this to your
                              attention before you place your order so that you
                              can decide whether or not you are prepared to
                              proceed with entering into the contract on that
                              basis.
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p>Obby Gift Cards</p>
                    <ol type="a">
                      <li>
                        <p>
                          A refund of the applicable amount via the original
                          method of payment is possible if you cancel (in whole
                          or in part) an Obby Gift Card within 24 hours of
                          receiving your Order Confirmation, provided you have
                          not already used it to redeem against a booking.
                        </p>
                      </li>
                      <li>
                        <p>
                          If permitted by these Booking Terms and Conditions and
                          the relevant Partner Terms and Conditions,
                          cancellations of Obby Gift Cards must be made by one
                          of the following methods:
                        </p>
                        <ul>
                          <li>
                            <p>Via the Website;</p>
                          </li>
                          <li>
                            <p>
                              Following the link in your Order Confirmation
                              email; or
                            </p>
                          </li>
                          <li>
                            <p>
                              Emailing our Customer Care team on{" "}
                              <a href="mailto:hello@obby.co.uk">
                                hello@obby.co.uk
                              </a>
                              .
                            </p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <p>
                          No refund will be given where a cancellation is
                          attempted more than 24hrs after receiving your Order
                          Confirmation.
                        </p>
                      </li>
                      <li>
                        <p>
                          No refund will be given where a cancellation is
                          attempted once an Obby Gift Card has been fully
                          redeemed, either via a booking with a partner being
                          booked or by being redeemed against another purchase.
                        </p>
                      </li>
                      <li>
                        <p>
                          Please also note that where a cancellation is
                          attempted once an Obby Gift Card has been redeemed in
                          part, either via a booking with a partner being booked
                          or by being redeemed against another purchase. No
                          refund will be given in respect of the redeemed part
                          of the Obby Gift Card.
                        </p>
                      </li>
                      <li>
                        <p>
                          Please also note that no refund will be given where a
                          Gift Card has been purchased via the “Gift This Class”
                          feature and the “suggested class” is no longer
                          available.
                        </p>
                      </li>
                    </ol>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  The Order process allows you to check and amend any errors
                  before submitting your Order to us. Please take the time to
                  read and check your Order at each stage of the Order process
                  and before finally submitting your Order.
                </p>
              </li>
              <li>
                <p>
                  We are appointed as the commercial agent of the Partner to
                  conclude bookings on its behalf and the Partner Contract will
                  be formed when we send you a written confirmation (usually by
                  email) ("Order Confirmation"). In respect of Orders for Obby
                  Gift Cards, receipt of an electronic voucher (if earlier) will
                  count as an Order Confirmation.
                </p>
              </li>
              <li>
                <p>
                  For Dated Booking Orders, if you wish to reschedule your
                  booking details (time/date) (in whole or in part) after you
                  have received an Order Confirmation, provided your booking is
                  not due to take place within the next 7 days, then please
                  contact us and we will endeavour to offer you a suitable
                  alternative booking time and/or date. If we are unable to
                  accommodate your request to reschedule your booking:
                </p>
                <ul>
                  <li>
                    <p>
                      if you contacted us to do so within 24 hours of receiving
                      your Order Confirmation, we will offer you a refund in
                      respect of the part of your Order which we are unable to
                      reschedule; or
                    </p>
                  </li>
                  <li>
                    <p>
                      if you contacted us to do so 24 hours or more from
                      receiving your Order Confirmation, provided the booking
                      was not due to take place within the next 7 days from the
                      time you asked to reschedule (such timeframe as determined
                      by the Partner and notified to you on making your Order),
                      we will offer you a refund in respect of the part of your
                      Order which we are unable to reschedule; or
                    </p>
                  </li>
                  <li>
                    <p>
                      if you contacted us to do so 24 hours or more from
                      receiving your Order Confirmation, and the booking is due
                      to take place within the next 7 days from the time you
                      asked to reschedule (such timeframe as determined by the
                      Partner and notified to you on making your Order), you
                      will not be eligible for a refund in respect of your
                      Order.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  You can contact us to reschedule a booking at
                  hello@obby.co.uk, via the Website or by following the link in
                  your Order Confirmation email. Please note that our ability to
                  accommodate your request will be subject to the Partner's
                  availability during the time you wish to reschedule.
                </p>
              </li>
              <li>
                <p>
                  If you wish to cancel an Order before you have received an
                  Order Confirmation, please notify us immediately by emailing
                  hello@obby.co.uk. If you wish to cancel a Partner Contract
                  (i.e. if you wish to cancel an Order after you have received
                  an Order Confirmation), please refer to our cancellation
                  policy in the Cancellations clauses below.
                </p>
              </li>
              <li>
                <p>
                  Please note, as set out in our Website Terms of Use, we
                  reserve the right to withdraw access to our Website and/or
                  cancel any Order in the event that you fail any credit or
                  fraud prevention check or where we reasonably suspect fraud or
                  money laundering by you or someone using your account.
                </p>
              </li>
            </ol>
          </li>
        </ol>

        {/* PRICE AND PAYMENT */}
        <ol start="6">
          <li>
            <p>Price and payment</p>
            <ol>
              <li>
                <p>
                  Prices and any applicable delivery and/or processing charges
                  will be as quoted on the Website from time to time, but may be
                  subject to change by Obby or Partners at any time (in which
                  case the Website will be updated accordingly, but changes will
                  not affect Orders in respect of which you have already been
                  sent an Order Confirmation prior to the date the change is
                  published on the Website).
                </p>
              </li>
              <li>
                <p>
                  Prices include VAT where applicable unless it is stated
                  otherwise on the relevant page in relation to the relevant
                  Services.
                </p>
              </li>
              <li>
                <p>
                  The Website contain details of a number of Services and it is
                  possible that, despite Obby's best efforts, some of the
                  pricing and other information shown for certain Services is
                  incorrect.
                </p>
              </li>
              <li>
                <p>
                  Payment for all Services must be made at the time of booking
                  in pounds sterling by credit or debit card, or via a third
                  party payment processor such as Stripe or by using the online
                  payment facility ("Payment Facility"). If you do choose to pay
                  via a third party payment processor, you will be redirected to
                  their site to make payment and will be subject to their terms
                  and conditions, privacy policy and other terms of use. Please
                  check those carefully before confirming your booking You will
                  be responsible for protecting the confidentiality of your
                  Website and any password or other security information used by
                  you to access your account on the Payment Facility. Any
                  currency conversion costs or other charges incurred by you in
                  making a payment will be borne by you in addition to the price
                  due to us.
                </p>
              </li>
              <li>
                <p>
                  Payments made through the Payment Facility are processed by
                  third party payment services providers. Obby takes reasonable
                  care to ensure that the Payment Facility is available and
                  functioning at all times, but cannot guarantee continuous,
                  uninterrupted or secure access to such Payment Facility, nor
                  can we guarantee that the facility is virus or error free. We
                  use third party payment service providers to process payments
                  and because there are many factors beyond our control (such as
                  delays in the banking system or in card networks), we cannot
                  predict or guarantee the amount of time needed to complete the
                  processing of your payment. Access to the Payment Facility may
                  be occasionally restricted to allow for repairs, maintenance
                  or the introduction of new facilities or services. We will
                  attempt to provide reasonable notice of any scheduled
                  interruptions to such Payment Facility and will do what we can
                  to restore the facility as soon as reasonably possible.
                </p>
              </li>
              <li>
                <p>
                  If you pay for Services via the Payment Facility, Obby will
                  collect the payment in its capacity as the commercial agent of
                  the relevant Partner. Once Obby has successfully received your
                  payment for the Services, this will discharge your debt to the
                  Partner on whose behalf Obby has collected the payment.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Liability</p>
            <ol>
              <li>
                <p>
                  Where we have been negligent and/or breached a contractual
                  obligation to you, we will be liable for any loss or damage
                  you suffer as a result, provided that loss and/or damage is
                  foreseeable. Loss or damage is foreseeable if it is an obvious
                  consequence of our negligence or breach of contract, or would
                  have been considered by you and us to be a likely consequence
                  of it at the time we entered into the Obby Contract.
                </p>
              </li>
              <li>
                <p>
                  We do not accept any liability for the following types of
                  loss, whether caused by breach of contract, tort (including
                  negligence) or otherwise, even if the loss is foreseeable:
                  loss of income or revenue; loss of business; loss of profits;
                  loss of anticipated savings; loss of data; or waste of
                  management or office time.
                </p>
              </li>
              <li>
                <p>
                  We do not exclude or limit our liability for death or personal
                  injury arising from our negligence, for fraud or fraudulent
                  misrepresentation, or for any other liability which cannot be
                  excluded or limited under English law.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Our right to vary these Booking Terms and Conditions</p>
            <ol>
              <li>
                <p>
                  We may revise these Booking Terms and Conditions from time to
                  time in the following circumstances:
                </p>
                <ul>
                  <li>
                    <p>
                      if we change the process for accepting payment from you;
                    </p>
                  </li>
                  <li>
                    <p>
                      if there are changes in relevant laws and regulatory
                      requirements; and/or
                    </p>
                  </li>
                  <li>
                    <p>
                      if there are any other changes to our business that
                      reasonably means we need to amend these Booking Terms and
                      Conditions.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  Every time you order Services or Obby Gift Cards via the
                  Website, the Booking Terms and Conditions in force at that
                  time (and available for view on the Website) will apply to the
                  Obby Contract between you and us. You can find the date on
                  which these Booking Terms and Conditions were last updated at
                  the top of this page.
                </p>
              </li>
            </ol>
          </li>
        </ol>

        <ol start="9">
          <li>
            <p>General</p>
            <ol>
              <li>
                <p>
                  All communications and notices from you must be sent to Obby
                  by email at hello@obby.co.uk or by post to: Obby, 110 Clifton
                  Street, Stapleton House, 2<sup>nd</sup> Floor, London, EC2A
                  4HT. Obby may communicate and give notice to you via post,
                  email or by posting notices on the Website.
                </p>
              </li>
              <li>
                <p>
                  Please note our customer support hours are: 8am-8pm Monday to
                  Friday.
                </p>
              </li>
              <li>
                <p>
                  If any of these Booking Terms and Conditions are determined by
                  a competent authority to be invalid, unlawful or unenforceable
                  to any extent, such term, condition or provision will to that
                  extent be severed from the remaining terms, conditions and
                  provisions which will continue to be valid to the fullest
                  extent permitted by law.
                </p>
              </li>
              <li>
                <p>
                  These Booking Terms and Conditions will be governed by and
                  construed in accordance with the laws of England. You and we
                  each agree that the English courts will have non-exclusive
                  jurisdiction over any claim or dispute arising from, or
                  related to, the ordering and/or supply of Services via the
                  Website.
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <ol start="10">
          <li>
            <p> The Obby Guarantee</p>
            <ol>
              <li>
                <p>
                  The Obby Guarantee states that 'If your class doesn't reach
                  your expectations, we'll give your money back."
                </p>
              </li>
              <li>
                <p>
                  For a one-off class, you must contact Obby within 7 days of
                  the class date to be eligible to receive a full refund, at
                  that point Obby has the right to investigate any claims made
                  by you with the class host and has 30 days to resolve any
                  issues that may arise.
                </p>
              </li>
              <li>
                <p>
                  For a block booking or course, you must make contact with Obby
                  before the 3rd session of the course and decide that it is not
                  suitable and you would like a refund. If you complete a
                  block-booking or course of 3 or more sessions and have not
                  notified Obby before the 3rd session, you will not be eligible
                  to claim back on the Obby guarantee.
                </p>
              </li>
              <li>
                <p>
                  If you fail to read the class description in full and want to
                  make a claim based on a factor included in the description
                  (for example class size, structure or materials) you will not
                  be eligible for a refund.
                </p>
              </li>
              <li>
                <p>
                  If you would like to claim money back for a class or course
                  that does not reach your expectations please email
                  hello@obby.co.uk with details of your booking and the reasons
                  why you are eligible for a refund.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  );
}
